<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> EMISSÃO DE FATURA ROYALTIES GRUPO </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      >
      </alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="parcels"
                v-model="parcel"
                label="Nº Parcelas"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                label="Data Primeira Parcela"
                v-mask="dateMask"
                outlined
                dense
                hide-details
                v-model="fisrt_parcel"
                append-outer-icon="mdi-calendar"
                @click:append-outer="handleClickCalendar('fisrt_parcel', null)"
              ></v-text-field>
              <!-- <v-text-field
              label="Data Primeira Parcela"
              outlined
              dense
              hide-details
              v-model="fisrt_parcel"
              v-mask="'##/##/####'"
              ></v-text-field> -->
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                label="Intervalo entre Parcelas"
                v-model="interval"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-1"
                @click="loadInvoices"
              >
                <v-icon left> mdi-plus </v-icon>
                Carregar Franqueados
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card>
                <v-toolbar
                  color="blue darken-4"
                  class="font-weight-bold"
                  dense
                  outlined
                  height="28"
                  dark
                  >FATURAMENTO</v-toolbar
                >
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="350">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <!-- <th class="text-left fs-12 text-no-wrap">Ação</th> -->
                              <th class="text-left fs-12 text-no-wrap">
                                Filial
                              </th>
                              <th class="text-left fs-12" width="250px">
                                Franqueado
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                ($) Notas
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Qtde
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                ($) Desconto
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                ($) Encargos
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                ($) Base Calc.
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                (%) Royalties
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                ($) Royalties
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Parcelas
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                ($) Parcela
                              </th>
                              <th class="text-center fs-12 text-no-wrap">
                                Data 1
                              </th>
                              <th class="text-center fs-12 text-no-wrap">
                                Data 2
                              </th>
                              <th class="text-center fs-12 text-no-wrap">
                                Data 3
                              </th>
                              <th class="text-center fs-12 text-no-wrap">
                                Data 4
                              </th>
                              <th class="text-center fs-12 text-no-wrap">
                                Data 5
                              </th>
                              <th class="text-center fs-12 text-no-wrap">
                                Data 6
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in invoices"
                              :key="item.franchise_id"
                              :class="item.check ? 'yellow lighten-4' : ''"
                            >
                              <!-- <td></td> -->
                              <td class="text-center">
                                {{ item.franchise.code }}
                              </td>
                              <td>{{ item.franchise.name }}</td>
                              <td class="text-right">
                                {{ item.total | currencyEuaToBr }}
                              </td>
                              <td class="text-right">
                                {{ item.quantity }}
                              </td>
                              <td class="text-right">
                                {{ item.discount | currencyEuaToBr }}
                              </td>
                              <td class="text-right">
                                {{ item.addition | currencyEuaToBr }}
                              </td>
                              <td class="text-right">
                                {{ item.total | currencyEuaToBr }}
                              </td>
                              <td class="text-right">{{ item.royalties }}</td>
                              <td class="text-right">
                                {{ item.royalties_value | currencyEuaToBr }}
                              </td>
                              <!-- <td class="text-right">{{ item.parcels }}</td> -->
                              <td>
                                <v-select
                                  :items="parcels"
                                  v-model="item.parcels"
                                  :disabled="
                                    parseFloat(item.royalties_value) == 0.0
                                  "
                                  @change="handleChangeParcel(item)"
                                  label=""
                                  hide-details
                                  dense
                                  outlined
                                  class="fs-12"
                                ></v-select>
                              </td>
                              <td class="text-right">
                                {{ item.parcel_value | currencyEuaToBr }}
                              </td>
                              <td
                                class="text-center justify-center"
                                v-for="(date, idx) in item.dates"
                                :key="`key_${idx}`"
                              >
                                {{ date }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn
                    dark
                    color="green darken-3"
                    class="float-right"
                    small
                    @click="handleSave()"
                  >
                    <v-icon left> mdi-check </v-icon>
                    Gerar Documento de Faturamento
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      ref="dialog"
      v-model="modalDate"
      :return-value.sync="dateDialog"
      width="290px"
    >
      <v-date-picker
        v-model="dateDialog"
        scrollable
        no-title
        @change="handlePickerDate"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalDate = false"> Fechar </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";
import AwesomeMask from "awesome-mask";

export default {
  components: { Alert },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    dateMask: "99/99/9999",
    parcels: [1, 2, 3, 4, 5, 6],
    parcel: "",
    interval: "",
    fisrt_parcel: "",
    minimum_value: "0.00",
    companies: [],
    companies_providers: [],
    company: "",
    provider: "",
    loading: false,
    successSave: false,
    lazy: false,
    valid: true,
    modalDate: false,
    dateDialog: "",
    objDateDialog: {},
    fieldDateDialog: "",
    showAlert: false,
    messageAlert: false,
    typeAlert: "error",
    invoices: [],
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {},
    validate() {},
    dateFormatToBr(date) {
      if (date == "") return "";
      return date.split("-").reverse().join("/");
    },
    dateFormatToEua(date) {
      if (date == "") return "";
      return date.split("/").reverse().join("-");
    },
    handleClickCalendar(field, obj) {
      let date = obj === null ? this[field] : obj[field];
      this.objDateDialog = obj;
      this.fieldDateDialog = field;
      this.dateDialog = this.dateFormatToEua(date);
      this.modalDate = true;
    },
    handlePickerDate() {
      this.modalDate = false;
      if (this.objDateDialog === null) {
        this[this.fieldDateDialog] = this.dateFormatToBr(this.dateDialog);
      } else {
        this.objDateDialog[this.fieldDateDialog] = this.dateFormatToBr(
          this.dateDialog
        );
        let companyCopies = [...this.companies];
        let companySelectedIndex = companyCopies.findIndex(
          (item) => item.company_id === this.objDateDialog.company_id
        );
        companyCopies[companySelectedIndex] = { ...this.objDateDialog };
        this.companies = [...companyCopies];
      }

      this.dateDialog = "";
      this.objDateDialog = {};
      this.fieldDateDialog = "";
    },
    async loadInvoices() {
      this.loading = true;
      this.showAlert = false;
      try {
        let res = await fetch(`${URL}invoice/invoice_group`);
        if (!res.ok) {
          throw new Error(res.message);
        }
        let data = await res.json();
        if (data.length === 0) {
          this.typeAlert = "warning";
          this.messageAlert = "Não existem notas para faturar";
          this.showAlert = true;
          this.$vuetify.goTo(0, {
            duration: 300,
            offset: 0,
            easing: "easeInOutCubic",
          });
        }
        this.invoices = this.groupBy(data, "franchise_id")
          .sort((a, b) => (a.code < b.code ? -1 : 1))
          .map((item) => ({
            ...item,
            parcels: parseFloat(item.royalties_value) == 0 ? 1 : item.parcels,
          }));
        console.log(this.invoices);
        // this.invoices = this.groupBy(this.filterByRestitution(data, 0));
        // this.invoices_restitution = this.filterByRestitution(data, 1).map(
        //   (item) => ({ ...item, royalties: 0 })
        // );
        // console.log(this.invoices);
      } catch (error) {
        console.log(error);
        this.typeAlert = "error";
        this.messageAlert =
          "Houve um problema ao carregar as notas, tente novamente mais tarde";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
      } finally {
        this.loading = false;
      }
    },
    // filterByRestitution(data, restitution) {
    //   return data
    //     .map((item) => ({
    //       ...item,
    //       orders: item.orders.filter((ord) => ord.restitution == restitution),
    //     }))
    //     .filter((item) => item.orders.length > 0)
    //     .map((item) => ({
    //       ...item,
    //       quantity: item.orders
    //         .map((ord) => ord.quantity_served)
    //         .reduce((prev, curr) => parseInt(prev) + parseInt(curr), 0),
    //       value: item.orders
    //         .map((ord) => ord.value_served)
    //         .reduce((prev, curr) => parseFloat(prev) + parseFloat(curr), 0)
    //         .toFixed(2),
    //     }));
    // },
    groupBy(data, field) {
      // let fields = [...new Set(data.map((item) => item[field]))];
      let registers = [];
      data.map((item) => {
        let hasReg = registers.findIndex((reg) => reg[field] === item[field]);
        if (hasReg <= -1) {
          registers.push({
            [field]: item[field],
            code: item.franchise.code,
            franchise: item.franchise,
            royalties: item.royalties,
            parcels: this.parcel,
            dates: this.getDates(item.royalties),
            invoices: [item],
          });
        } else {
          registers[hasReg].invoices.push(item);
        }
      });
      registers = registers.map((item) => ({
        ...item,
        total: this.getTotal(item),
        discount: this.getDiscountTotal(item),
        addition: this.getAdditionTotal(item),
        royalties_value: this.getValueRoyalties(item),
        parcel_value: this.getValueParcel(item),
        quantity: this.getQuantityTotal(item),
      }));
      console.log(registers);
      return registers;
    },
    getDates(royalties) {
      let data = [];
      for (let i = 0; i < 6; i++) {
        if (royalties == 0) {
          data.push("");
        } else if (i >= this.parcel) {
          data.push("");
        } else {
          let [dayFirst, monthFirst, yearFirst] = [
            ...this.fisrt_parcel.split("/"),
          ];
          console.log({ dayFirst, monthFirst, yearFirst });
          let date = new Date(yearFirst, parseInt(monthFirst) - 1, dayFirst);
          let newDate = this.addDays(date, i * this.interval);
          // console.log(newDate);
          data.push(this.formatDate(newDate));
        }
      }
      return data;
    },
    addDays(date, days) {
      const dateCopy = new Date(date);
      dateCopy.setDate(date.getDate() + days);
      return dateCopy;
    },
    formatDate(date) {
      if (!date) return "";
      return `${date.getDate().toString().padStart(2, 0)}/${(
        date.getMonth() + 1
      )
        .toString()
        .padStart(2, 0)}/${date.getFullYear()}`;
    },
    getTotal(item) {
      let total = item.invoices.reduce(
        (acc, prev) => acc + parseFloat(prev.value),
        0
      );
      return total;
    },
    getQuantityTotal(item) {
      let total = item.invoices.reduce(
        (acc, prev) => acc + parseInt(prev.quantity),
        0
      );
      return total;
    },
    getDiscountTotal() {
      return 0;
      // let total = item.invoices.reduce(
      //   (acc, prev) => acc + parseFloat(prev.discount),
      //   0
      // );
      // return total;
    },

    getAdditionTotal() {
      return 0;
      // let total = item.invoices.reduce(
      //   (acc, prev) => acc + parseFloat(prev.addition),
      //   0
      // );
      // return total;
    },
    getValueParcel(item) {
      if (parseFloat(item.royalties) <= 0) {
        return 0;
      }
      let total = this.getTotal(item);
      let value = (total * (parseFloat(item.royalties) / 100)).toFixed(2);
      return (value / item.parcels).toFixed(2);
    },
    getValueRoyalties(item) {
      if (parseFloat(item.royalties) <= 0) {
        return 0;
      }
      let total = this.getTotal(item);
      return (total * (parseFloat(item.royalties) / 100)).toFixed(2);
    },
    async handleSave() {
      this.loading = true;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}invoice/save_invoice_group`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            invoices: this.invoices,
          }),
        });
        res = await res.json();
        console.log(res);
        this.invoices = [];
        this.parcel = "";
        this.fisrt_parcel = "";
        this.interval = "";
        this.typeAlert = "success";
        this.messageAlert = "Faturas de Royalties geradas com sucesso";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
      } catch (error) {
        this.invoices = [];
        this.parcel = "";
        this.fisrt_parcel = "";
        this.interval = "";
        this.typeAlert = "error";
        this.messageAlert =
          "Não foi possível gerar todas as faturas de royalties em grupo, confira em Impressão de Fatura quais foram concluidas e repita o processo com o restante.";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
      } finally {
        this.loading = false;
      }
      console.log(this.invoices);
    },
    handleChangeParcel(item) {
      console.log(item);
      let [day, month, year] = this.fisrt_parcel.split("/");
      let date1 = new Date(year, month - 1, day);
      let date2 = new Date(date1);
      let date3 = new Date(date1);
      let date4 = new Date(date1);
      let date5 = new Date(date1);
      let date6 = new Date(date1);

      date2.setDate(date2.getDate() + parseInt(this.interval));
      date3.setDate(date3.getDate() + this.interval * 2);
      date4.setDate(date4.getDate() + this.interval * 3);
      date5.setDate(date5.getDate() + this.interval * 4);
      date6.setDate(date6.getDate() + this.interval * 5);

      item.dates[1] =
        item.parcels >= 2 ? `${date2.toLocaleDateString("pt-BR")}` : "";

      item.dates[2] = item.date3 =
        item.parcels >= 3 ? `${date3.toLocaleDateString("pt-BR")}` : "";
      item.dates[3] =
        item.parcels >= 4 ? `${date4.toLocaleDateString("pt-BR")}` : "";
      item.dates[4] =
        item.parcels >= 5 ? `${date5.toLocaleDateString("pt-BR")}` : "";
      item.dates[5] =
        item.parcels >= 6 ? `${date6.toLocaleDateString("pt-BR")}` : "";

      let value = parseFloat(item.royalties_value);
      let parcel_value = (value / item.parcels).toFixed(2);
      item.parcel_value = parcel_value;
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
</style>
